export const Footer = () => {
	return (
		<footer className="Footer-container text-muted f-medium">
			<div>© 2024 React Webshop</div>
			<div> ✨ Made by &nbsp;
				<a href="https://github.com/marination">@marination</a>
				✨
			</div>
		</footer>
	);
}